import { render, staticRenderFns } from "./FullWidthBlock.vue?vue&type=template&id=6b78bae4&"
import script from "./FullWidthBlock.vue?vue&type=script&lang=js&"
export * from "./FullWidthBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports